export default "__VITE_ASSET__546bac7a__"